// municipal-regulations.service.ts
import { Injectable } from '@angular/core';
import { Observable ,of} from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/common/services/api.service';
import { apiEndPoints } from 'src/app/common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MunicipalRegulationsService {

  constructor(
    private apiService: ApiService,
    private reportService: ReportService
  ) {}

  getPermissibleUsageData(parcelUid: string): Observable<any[]> {
    if (!parcelUid) {
      return of([]);
    }

    let url = `${environment.miUrl}${apiEndPoints.farUsage}?parcel_uid=${parcelUid}`;

    const queryParams = { ...this.reportService.queryParams };
    if (queryParams?.rid) {
      url += `&report_id=${queryParams.rid}`;
    }
    if (queryParams?.year) {
      url += `&year=${queryParams.year}`;
    }

    return this.apiService.get(url, false).pipe(
      map((response: any) => {
        if (response.status === 200 && response.data) {
          return response.data;
        }
        return [];
      })
    );
  }
}